<template>
  <div class="container upcoming-content home-p-color">
    <div class="content center-margin">
      <div class="step center-aligned">
        <img
          class="correct"
          src="/official/static/img/events/activate/3/correct.png"
        >
        <h2 class="tips">
          {{ $t('ppwc.p50') }}
        </h2>
        <div class="content">
          <img
            class="correct"
            src="/official/static/img/events/activate/3/talk.png"
          >
          <div class="contact">
            <p><strong>{{ $t('ppwc.p51') }}</strong></p>
            <p style="margin-bottom: 14px;">
              {{ $t('ppwc.p52') | format }} <a
                class="home-color"
                place="link"
                href="mailto:info@pppoker.net"
              >info@pppoker.net</a>
            </p>
            <p><strong>{{ $t('ppwc.p53') }}</strong></p>
            <p>
              {{ $t('ppwc.p54') | format }} <a
                class="home-color"
                place="link"
                href="mailto:events@pppoker.net"
              >events@pppoker.net</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    format: function(val) {
      return val.replace('{link}', '')
    }
  },
  data() {
    return {
      num: 5
    }
  },
  mounted() {
    // let interval = setInterval(() => {
    //   if(this.num == '0') {
    //     clearInterval(interval);
    //     return this.$router.push({name: 'home'})
    //   }
    //   this.num--
    // }, 1000);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.banner_img {
  height: 410px;
  background: url("/official/static/img/events/banner1.jpg") center center;
  background-repeat: no-repeat;
}
.upcoming-content {
  padding-top: 65px;
  padding-bottom: 65px;
  .content {
    width: 620px;
  }
}
.step {
  padding-top: 20px;
  .tips {
    margin: 15px 0px;
    font-size: 28px;
    line-height: 34px;

  }
  .content {
    padding: 20px 0px;
  }
  .correct {
    display: inline-block;
    vertical-align: middle;
    width: 70px;
  }
  .contact {
    margin-top: 10px;
    margin-left: 30px;
    text-align: center;
    p {
      font-size: 20px;
    }
    a {
      box-shadow: 0 1px;
    }
  }
}
</style>
